import { OrderData } from '~/shared/api/services/warehouses/types'
import { LinkButton } from '~/shared/ui/link-button'

interface AssemblyOrderCardProps {
  order: OrderData
  className: string
  adaptiveFontSize: (text: string) => string
  onOpen: (order: OrderData) => void
}

export const AssemblyOrderCard = ({
  order,
  className,
  adaptiveFontSize,
  onOpen,
}: AssemblyOrderCardProps) => (
  <LinkButton
    key={order.id}
    className={className}
    intent={order.express ? 'express' : order.style}
    badgeContent={order.badge}
    isDeferred={order.isDeferred}
    href={`/assembly/${order.id}/items`}
    onClick={() => onOpen(order)}
  >
    <div className="relative z-10 flex flex-col w-[100%]">
      <div className={adaptiveFontSize(order.number)}>
        {order.number + (order.label ? order.label : '')}
      </div>
      <div className="text-[12px]">
        {order.number !== order.systemNumber ? `(${order.systemNumber})` : ''}
      </div>
    </div>
  </LinkButton>
)
